// src/pages/hr/HRRecruitment.jsx
import React, { useState } from "react";
import { HR_NAV } from "../../utils/navigation";
import Layout from "../../components/common/Layout";
import { RecruitmentProvider } from "../../context/RecruitmentContext";

import RecruitmentDashboard from "./recruitment/RecruitmentDashboard";
import JobOpenings from "./recruitment/JobOpenings";
import CandidateList from "./recruitment/CandidateList";
import PipelineKanban from "./recruitment/PipelineKanban";
import InterviewScheduler from "./recruitment/InterviewScheduler";
import HiringRequests from "./recruitment/HiringRequests";
import RecruitmentActivity from "./recruitment/RecruitmentActivity";

const PANEL_LABEL = "HR Panel";

export default function HRRecruitment() {
  const [activeTab, setActiveTab] = useState("dashboard");

  return (
    <Layout navItems={HR_NAV} panelLabel={PANEL_LABEL}>
      <RecruitmentProvider>
        <style>{`
          .ats-tabs-bar { display: flex; gap: 0.5rem; border-bottom: 2px solid var(--border, #e5e7eb); margin-bottom: 1.5rem; overflow-x: auto; padding-bottom: 2px; }
          .ats-tab-btn { padding: 0.65rem 1.25rem; background: none; border: none; font-weight: 600; font-size: 0.86rem; cursor: pointer; color: var(--text-muted, #6b7280); border-bottom: 3px solid transparent; margin-bottom: -2px; white-space: nowrap; transition: all 0.2s; }
          .ats-tab-btn:hover { color: var(--brand-accent); }
          .ats-tab-btn.active { color: #1b4b31; border-bottom-color: #1b4b31; font-weight: 700; }
        `}</style>

        {/* Module Title Header */}
        <div className="page-header" style={{ marginBottom: "1rem" }}>
          <div>
            <h1 className="page-title">Enterprise Recruitment ATS</h1>
            <p className="page-subtitle">Manage job requisitions, applicant pipeline, interviews, and hiring analytics</p>
          </div>
        </div>

        {/* ATS Module Navigation Bar */}
        <div className="ats-tabs-bar">
          {[
            { id: "dashboard", label: "📊 Overview" },
            { id: "jobs", label: "📋 Job Openings" },
            { id: "candidates", label: "👤 Candidates" },
            { id: "pipeline", label: "🔄 Pipeline Kanban" },
            { id: "interviews", label: "📅 Interviews" },
            { id: "requests", label: "📥 Hiring Requests" },
            { id: "activity", label: "⚡ Audit Logs" },
          ].map((t) => (
            <button
              key={t.id}
              className={`ats-tab-btn ${activeTab === t.id ? "active" : ""}`}
              onClick={() => setActiveTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* Tab View Component Rendering */}
        <div>
          {activeTab === "dashboard" && <RecruitmentDashboard />}
          {activeTab === "jobs" && <JobOpenings />}
          {activeTab === "candidates" && <CandidateList />}
          {activeTab === "pipeline" && <PipelineKanban />}
          {activeTab === "interviews" && <InterviewScheduler />}
          {activeTab === "requests" && <HiringRequests />}
          {activeTab === "activity" && <RecruitmentActivity />}
        </div>
      </RecruitmentProvider>
    </Layout>
  );
}
